import { geocodeByAddress } from 'react-places-autocomplete';
import normalizeGoogleAddress from './normalizeGoogleAddress';
import isString from 'lodash/isString';
import split from 'lodash/split';

export default function getGeocodedNormalizedAddress(addressObj) {
  if (window.Cypress && process.env.REACT_APP_ENV !== 'qa') {
    let address;
    if (isString(addressObj)) {
      if (window.Cypress.spec.name === 'user_views_landing_pages.spec.js') {
        return Promise.resolve({
          region: {
            code:
              [
                '29010',
                '29211',
                '29479',
                '29486',
                '29544',
                '29673',
                '29673-1332',
              ].indexOf(addressObj) > -1
                ? 'SC'
                : 'CA',
          },
        });
      }
      address = {};
      const addressList = split(addressObj, ',');
      const statePostalList = split(addressList[2].trim(), ' ');
      address['line1'] = addressList[0];
      address['city'] = addressList[1].trim();
      address['region'] = {
        code: statePostalList[0],
        name: statePostalList[0],
      };
      address['postal'] = statePostalList[1];
      address['country'] = {
        code: 'US',
        name: 'United States',
      };
    }
    return Promise.resolve(address || addressObj);
  }

  const addressStr = isString(addressObj)
    ? addressObj
    : [
        addressObj.line1,
        addressObj.city,
        addressObj.region,
        addressObj.postal,
      ].join(' ');

  return geocodeByAddress(addressStr).then((geocodedAddress) => {
    const location = geocodedAddress[0].geometry.location;
    const normalizedAddress = normalizeGoogleAddress(geocodedAddress[0]);

    const { line1, city } = normalizedAddress;
    const splitAddressStr = addressStr.split(',');
    if (splitAddressStr.length > 2 && (!line1 || !city)) {
      const manualNormalizedAddress = {
        ...normalizedAddress,
        line1: splitAddressStr[0].trim(),
        city: splitAddressStr[1].trim(),
      };
      return {
        ...manualNormalizedAddress,
        latitude: location.lat(),
        longitude: location.lng(),
      };
    } else {
      return {
        ...normalizedAddress,
        latitude: location.lat(),
        longitude: location.lng(),
      };
    }
  });
}
